(function () {
  'use strict';

  var DEBUG = /[?&]vrdebug=1/.test(window.location.search);

  /* Last-resort deposit in cents, keyed by variant id. Only used if sources
     1 to 3 all miss. Keep in sync with Downpay. */
  var DEPOSITS = {
    53628734964025: 14900   /* PRIME-TRY-TBYB */
  };

  var NOTE = 'before tax and shipping';

  var CART_ROOT     = '.rebuy-cart';
  var CART_ITEMS    = '[data-rebuy-component="cart-items"]';
  var CHECKOUT_AREA = '[data-rebuy-component="checkout-area"]';
  var SUBTOTAL      = '[data-rebuy-component="cart-subtotal"]';

  var pending   = null;
  var lastFetch = 0;
  var COOLDOWN  = 1500;   /* ms. Applies to observer-triggered renders only. */

  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[downpay]'].concat(Array.prototype.slice.call(arguments)));
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* Pull "149" out of "Pay $149 now, $249 in 30 days" or "$149.00 today". */
  function depositFromName(name) {
    if (!name) return null;
    var m = String(name).match(/\$\s*([\d,]+(?:\.\d{1,2})?)\s*(?:now|today|upfront|down)/i);
    if (!m) return null;
    var dollars = parseFloat(m[1].replace(/,/g, ''));
    return isNaN(dollars) ? null : Math.round(dollars * 100);
  }

  /* PER UNIT deposit in cents, or null if this line is not deferred. */
  function unitDeposit(item) {
    var alloc = item.selling_plan_allocation;
    if (!alloc) { log(item.product_title, 'no allocation'); return null; }

    var unitPrice = item.final_price;
    var found = null;
    var via = null;

    if (alloc.checkout_charge_amount != null && alloc.checkout_charge_amount > 0) {
      found = alloc.checkout_charge_amount; via = 'checkout_charge_amount';
    }
    if (found == null && alloc.remaining_balance_charge_amount != null && alloc.price != null) {
      found = alloc.price - alloc.remaining_balance_charge_amount; via = 'remaining_balance';
    }
    if (found == null) {
      var plan = alloc.selling_plan || {};
      found = depositFromName(plan.name || alloc.selling_plan_name);
      if (found != null) via = 'plan name';
    }
    if (found == null && DEPOSITS[item.variant_id] != null) {
      found = DEPOSITS[item.variant_id]; via = 'DEPOSITS map';
    }

    if (found == null) {
      log('no deposit source for', item.product_title, '| allocation:', JSON.stringify(alloc));
      return null;
    }
    if (found <= 0 || found >= unitPrice) {
      log('deposit', money(found), 'not below unit price', money(unitPrice), '| ignoring');
      return null;
    }

    log(item.product_title, 'deposit', money(found), 'via', via);
    return found;
  }

  /* Sum what the card is actually charged at checkout, and remember the
     deposit/balance per product handle for the line-item stacks. */
  function computeDueToday(cart) {
    var total = 0;
    var hasDeferred = false;
    var split = {};

    cart.items.forEach(function (item) {
      var deposit = unitDeposit(item);
      if (deposit != null) {
        hasDeferred = true;
        total += deposit * item.quantity;
        var handle = item.handle || ((item.url || '').match(/\/products\/([^/?#]+)/) || [])[1];
        if (handle) split[handle] = { deposit: deposit, balance: item.final_price - deposit };
      } else {
        total += item.final_line_price;
        log(item.product_title, 'full', money(item.final_line_price));
      }
    });

    return { amount: total, hasDeferred: hasDeferred, split: split };
  }

  /* Replace the $398 on each deferred line with the two-part stack. The CSS
     hides the native price only once .hl-split-item is on the line, so if
     this never runs the stock display remains. Idempotent via data-sig. */
  function decorateLineItems(split) {
    var lines = document.querySelectorAll(CART_ITEMS + ' .rebuy-cart__flyout-item');
    Array.prototype.forEach.call(lines, function (line) {
      var a = line.querySelector('a[href*="/products/"]');
      var handle = null;
      if (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1];
      }

      var info = handle && split[handle];
      var priceEl = line.querySelector('.rebuy-cart__flyout-item-price');
      var node = priceEl && priceEl.querySelector('.hl-split');

      if (!info || !priceEl) {
        if (node) node.remove();
        line.classList.remove('hl-split-item');
        return;
      }

      var sig = info.deposit + '|' + info.balance;
      if (node && node.getAttribute('data-sig') === sig) {
        line.classList.add('hl-split-item');
        return;
      }
      if (node) node.remove();

      node = document.createElement('span');
      node.className = 'hl-split';
      node.setAttribute('data-sig', sig);
      node.innerHTML =
        '<span class="hl-split__now">' + money(info.deposit) + '<em>today</em></span>' +
        '<span class="hl-split__later">then ' + money(info.balance) + ' in 30 days</span>';
      priceEl.appendChild(node);
      line.classList.add('hl-split-item');
      log('decorated', handle, money(info.deposit), '+', money(info.balance));
    });
  }

  function teardown() {
    var row = document.querySelector('.hl-due-today');
    if (row) row.remove();
    document.querySelectorAll('.hl-split').forEach(function (n) { n.remove(); });
    document.querySelectorAll('.hl-split-item').forEach(function (n) { n.classList.remove('hl-split-item'); });
    document.querySelectorAll(CART_ROOT + '.hl-deferred').forEach(function (n) { n.classList.remove('hl-deferred'); });
  }

  /* Match the row's gutter to the subtotal's computed padding. */
  function matchGutter(row) {
    var sub = document.querySelector(SUBTOTAL);
    var cands = sub ? [sub, sub.firstElementChild] : [];
    for (var i = 0; i < cands.length; i++) {
      if (!cands[i]) continue;
      var p = getComputedStyle(cands[i]).paddingLeft;
      if (p && p !== '0px') { row.style.setProperty('--hl-pad', p); log('gutter matched to', p); return; }
    }
  }

  function render() {
    var root = document.querySelector(CART_ROOT);
    if (!root) { log('no .rebuy-cart on page yet'); return; }

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { teardown(); return; }

        var result = computeDueToday(cart);
        log('order total', money(cart.total_price), '| due today', money(result.amount));

        if (!result.hasDeferred) { teardown(); return; }

        /* Line-item stacks first. Runs every render because Rebuy re-renders
           the items area more often than the footer. */
        decorateLineItems(result.split);

        /* Due-today row. */
        var existing = document.querySelector('.hl-due-today');
        if (existing && existing.getAttribute('data-amount') === String(result.amount)) return;
        if (existing) existing.remove();

        var anchor = document.querySelector(CHECKOUT_AREA) || document.querySelector(SUBTOTAL);
        if (!anchor || !anchor.parentElement) { log('no anchor found'); return; }

        var row = document.createElement('div');
        row.className = 'hl-due-today';
        row.setAttribute('data-amount', String(result.amount));
        row.innerHTML =
          '<span class="hl-due-today__label">Due today' +
            '<span class="hl-due-today__note">' + NOTE + '</span>' +
          '</span>' +
          '<span class="hl-due-today__amount">' + money(result.amount) + '</span>';

        anchor.parentElement.insertBefore(row, anchor);
        matchGutter(row);

        /* The class goes on the cart that CONTAINS the row. The theme renders
           more than one .rebuy-cart, so querySelector alone hits the wrong one. */
        var cartEl = anchor.closest(CART_ROOT) || root;
        cartEl.classList.add('hl-deferred');
        log('injected', money(result.amount));
      })
      .catch(function (e) { log('failed', e.message); });
  }

  /* force === true for real cart events. Observer-triggered calls are
     throttled, otherwise ordinary DOM churn would fetch /cart.js several
     times a second on every cart with no deferred line. */
  function schedule(force) {
    clearTimeout(pending);
    pending = setTimeout(function () {
      if (force !== true && Date.now() - lastFetch < COOLDOWN) return;
      lastFetch = Date.now();
      render();
    }, 120);
  }

  /* Exposed BEFORE anything can throw, so diagnostics always work. */
  window.hlDueToday = {
    version: 5,
    render: render,
    compute: computeDueToday,
    unitDeposit: unitDeposit,
    dump: function () {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (!c.items.length) { console.log('[downpay] cart is empty'); return c; }
        c.items.forEach(function (i) {
          console.log(i.product_title, '| variant', i.variant_id, '| unit', money(i.final_price));
          console.log('  allocation:', i.selling_plan_allocation || 'NONE');
          console.log('  resolved deposit:', unitDeposit(i));
        });
        return c;
      });
    }
  };

  function boot() {
    log('script loaded, v5');

    ['rebuy:cart.change', 'rebuy:cart.refresh', 'rebuy:cart.ready',
     'rebuy:smartcart.show', 'rebuy:smartcart.open', 'cart:refresh']
      .forEach(function (evt) {
        document.documentElement.addEventListener(evt, function () { schedule(true); });
      });

    try {
      new MutationObserver(function () {
        var root = document.querySelector(CART_ROOT);
        if (!root) return;
        var rowMissing  = !document.querySelector('.hl-due-today');
        var splitsWiped = !!document.querySelector(CART_ROOT + '.hl-deferred') && !document.querySelector('.hl-split');
        if (rowMissing || splitsWiped) schedule();
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {
      log('observer failed', e.message);
    }

    schedule(true);
  }

  if (document.body) {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  }
})();
